<script>
	export let team1 = null;
	export let team2 = null;

	function pct(made, attempted) {
		const m = Number(made) || 0;
		const a = Number(attempted) || 0;
		if (a <= 0) {
			return null;
		}
		return (m / a) * 100;
	}

	function getRebound(t) {
		if (t?.rebound !== null && t?.rebound !== undefined) {
			return t.rebound;
		}
		return (Number(t?.defReb ?? t?.defRebound) || 0) + (Number(t?.offReb ?? t?.offRebound) || 0);
	}

	const STATS = [
		{ label: 'Очки', get: (t) => t?.points ?? 0, percent: false },
		{ label: '% 2-очковых', get: (t) => pct(t?.goal2, t?.shot2), percent: true },
		{ label: '% 3-очковых', get: (t) => pct(t?.goal3, t?.shot3), percent: true },
		{ label: '% штрафных', get: (t) => pct(t?.goal1, t?.shot1), percent: true },
		{ label: 'Подборы', get: (t) => getRebound(t), percent: false },
		{ label: 'Подборы в защите', get: (t) => t?.defReb ?? t?.defRebound ?? 0, percent: false },
		{ label: 'Подборы в нападении', get: (t) => t?.offReb ?? t?.offRebound ?? 0, percent: false },
		{ label: 'Передачи', get: (t) => t?.assist ?? 0, percent: false },
		{ label: 'Перехваты', get: (t) => t?.steal ?? 0, percent: false },
		{ label: 'Потери', get: (t) => t?.turnover ?? 0, percent: false },
		{ label: 'Блокшоты', get: (t) => t?.block ?? t?.blockShot ?? 0, percent: false },
		{ label: 'Фолы', get: (t) => t?.foul ?? 0, percent: false }
	];

	$: rows = buildRows(team1, team2);

	function formatValue(value, percent) {
		if (value === null || value === undefined) {
			return '—';
		}
		if (percent) {
			return `${(Number(value) || 0).toFixed(1)}%`;
		}
		return String(Number(value) || 0);
	}

	function buildRows(t1, t2) {
		return STATS.map((stat) => {
			const v1 = stat.get(t1) ?? 0;
			const v2 = stat.get(t2) ?? 0;
			const total = v1 + v2;
			const left = total > 0 ? (v1 / total) * 100 : 50;
			const right = total > 0 ? (v2 / total) * 100 : 50;
			return {
				label: stat.label,
				leftLabel: formatValue(v1, stat.percent),
				rightLabel: formatValue(v2, stat.percent),
				leftWidth: left,
				rightWidth: right
			};
		});
	}
</script>

<div class="cmp">
	{#each rows as row}
		<div class="cmp__row">
			<span class="cmp__value cmp__value--left">{row.leftLabel}</span>
			<div class="cmp__bar">
				<div class="cmp__bar-fill cmp__bar-fill--left" style="width: {row.leftWidth}%"></div>
				<div class="cmp__bar-fill cmp__bar-fill--right" style="width: {row.rightWidth}%"></div>
				<span class="cmp__bar-label">{row.label}</span>
			</div>
			<span class="cmp__value cmp__value--right">{row.rightLabel}</span>
		</div>
	{/each}
</div>

<style>
	:host { display: block; }
	.cmp {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
	.cmp__row {
		display: flex;
		align-items: center;
		gap: 12px;
	}
	.cmp__value {
		flex: 0 0 56px;
		font-size: 14px;
		font-weight: 800;
		color: #122033;
		white-space: nowrap;
	}
	.cmp__value--left { text-align: right; }
	.cmp__value--right { text-align: left; }
	.cmp__bar {
		position: relative;
		flex: 1;
		height: 22px;
		display: flex;
		border-radius: 7px;
		overflow: hidden;
		background: #f0f3f8;
	}
	.cmp__bar-fill--left {
		background: #0b4fa8;
	}
	.cmp__bar-fill--right {
		background: #e07800;
		margin-left: auto;
	}
	.cmp__bar-label {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		padding: 1px 9px;
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.88);
		font-size: 10px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.04em;
		color: #122033;
		white-space: nowrap;
	}
	@media (max-width: 640px) {
		.cmp__value { flex-basis: 40px; font-size: 12px; }
	}
</style>
